import { Component, Input } from '@angular/core';
import { TutorialService } from '../../../../shared/components/tutorial/tutorial.service';

@Component({
  selector: 'ngx-mostrar-tutorial',
  templateUrl: './mostrar-tutorial.component.html',
  styleUrls: ['./mostrar-tutorial.component.scss']
})
export class MostrarTutorialComponent {
  @Input() tutorialId: string;
  @Input() texto: string = '';
  @Input() icone: string = 'question-mark-circle-outline';
  @Input() status: string = 'info';
  @Input() tamanho: string = 'small';
  @Input() tooltip: string = 'Iniciar tutorial';

  constructor(private tutorialService: TutorialService) {}

  iniciarTutorial(): void {
    if (this.tutorialId) {
      this.tutorialService.resetarTutorial(this.tutorialId);
    }
  }
} 